export const STRAIGHTTRUCK = {
  label: 'STRAIGHT_TRUCK',
};

export const FLATBED = {
  label: 'FLATBED',
};

export const TRAILER = {
  label: '53_TRAILER',
};

export const VAN = {
  label: 'VAN',
};

export const POWERONLY = {
  label: 'POWER_ONLY',
};

export const PICKUP_TRUCK = {
  label: 'PICKUP_TRUCK',
};

export const CABINET_TRUCK = {
  label: 'CABINET_TRUCK',
};

export const FLATBED_TRUCK = {
  label: 'FLATBED_TRUCK',
};

export const CRANE_TRUCK = {
  label: 'CRANE_TRUCK',
};

export const REEFER_TRUCK = {
  label: 'REEFER_TRUCK',
};

export const FENCE_TRUCK = {
  label: 'FENCE_TRUCK',
};

export const CURTAIN_SIDED_TRUCK = {
  label: 'CURTAIN_SIDED_TRUCK',
};

export const TRAILER_SEMI_TRAILER = {
  label: 'TRAILER_SEMI_TRAILER',
};

export const CONESTOGA = {
  label: 'CONESTOGA',
};

export const DOUBLE_DROP = {
  label: 'DOUBLE_DROP',
};

export const DRY_VAN = {
  label: 'DRY_VAN',
};

export const FLATBED_HOTSHOT = { label: 'FLATBED_HOTSHOT' };

export const REEFER = { label: 'REEFER' };

export const REMOVABLE_GOOSENECK = { label: 'REMOVABLE_GOOSENECK' };

export const SPRINTER_VAN = { label: 'SPRINTER_VAN' };

export const STEP_DECK = { label: 'STEP_DECK' };

export const equipmentTypesUS = [
  { ...STRAIGHTTRUCK },
  { ...FLATBED },
  { ...TRAILER },
  { ...VAN },
  { ...POWERONLY },
];

export const equipmentTypesShorthaul = [
  { ...TRAILER },
  { ...FLATBED },
  { ...POWERONLY },
  { ...STRAIGHTTRUCK },
  { ...DRY_VAN },
];

export const equipmentTypesDayrate = [
  { ...TRAILER },
  { ...FLATBED },
  { ...POWERONLY },
  { ...STRAIGHTTRUCK },
  { ...DRY_VAN },
];

export const equipmentTypesLonghaul = [
  { ...TRAILER },
  { ...CONESTOGA },
  { ...DOUBLE_DROP },
  { ...DRY_VAN },
  { ...FLATBED },
  { ...FLATBED_HOTSHOT },
  { ...POWERONLY },
  { ...REEFER },
  { ...REMOVABLE_GOOSENECK },
  { ...SPRINTER_VAN },
  { ...STEP_DECK },
  { ...STRAIGHTTRUCK },
];

export function getEquipmentTypesForShipmentTypes(selectedShipmentTypes) {
  const typeMap = {
    shorthaul: equipmentTypesShorthaul,
    dayrate: equipmentTypesDayrate,
    longhaul: equipmentTypesLonghaul,
  };
  // Flatten, dedupe by label, and sort
  const all = selectedShipmentTypes.map((type) => typeMap[type] || []).flat();
  const deduped = Array.from(
    new Map(all.map((item) => [item.label, item])).values(),
  );
  return deduped.sort((a, b) => a.label.localeCompare(b.label));
}

export const equipmentTypes = equipmentTypesUS;
